module.exports = __webpack_public_path__ + "img/cits.532cbbbb.png";